import {
  ADD_SERVICE,
  ADD_SERVICE_FAILURE,
  ADD_SERVICE_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const addServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SERVICE:
      return { ...state, loading: true };
    case ADD_SERVICE_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case ADD_SERVICE_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default addServiceReducer;
